<template>
  <div>
    <div class="app-global-modal">
      <EventModalChangeCompany />
      <EventModalManagers />
      <EventModalUsers />
      <EventModalCompanyProfile />
      <EventModalParticipantPasses />
      <EventModalAutoPasses />
      <EventModalMontagePasses />
      <EventModalDetailPass />
      <EventModalCatalog />
      <EventModalCatalogRubrics />
      <EventModalSubexponent />
      <EventModalDocumentsIssuedInvoices />
      <EventModalDocumentsActs />
      <EventModalEdoSettings />
      <EventModalCategories />
      <FeedbackModal />
      <ChatModal />
      <ServiceModal />
      <AlertModal />
      <OrderSuccessModal />
    </div>
    <div
      @click="hideOverlay"
      :class="{ 'overlay--visible': isOverlayVisible }"
      class="overlay"
    ></div>
  </div>
</template>

<script>
import EventModalUsers from "@/components/Modal/EventModalUsers.vue";
import EventModalCompanyProfile from "@/components/Modal/EventModalCompanyProfile.vue";
import EventModalParticipantPasses from "@/components/Modal/Passes/EventModalParticipantPasses.vue";
import EventModalAutoPasses from "@/components/Modal/Passes/EventModalAutoPasses.vue";
import EventModalMontagePasses from "@/components/Modal/Passes/EventModalMontagePasses.vue";
import EventModalDetailPass from "@/components/Modal/Passes/EventModalDetailPass.vue";
import EventModalCatalog from "@/components/Modal/Catalog/EventModalCatalog";
import EventModalCatalogRubrics from "@/components/Modal/Catalog/EventModalCatalogRubrics";
import EventModalSubexponent from "@/components/Modal/Subexponent/EventModalSubexponent";
import EventModalManagers from "@/components/Modal/EventModalManagers.vue";
import EventModalChangeCompany from "@/components/Modal/ChangeCompany/EventModalChangeCompany.vue";
import EventModalDocumentsIssuedInvoices from "@/components/Modal/Documents/EventModalDocumentsIssuedInvoices";
import EventModalDocumentsActs from "@/components/Modal/Documents/EventModalDocumentsActs";
import EventModalEdoSettings from "@/components/Modal/EventModalEdoSettings";
import EventModalCategories from "@/components/Modal/Services/EventModalCategories";
import FeedbackModal from "@/components/Custom/FeedbackModal.vue";
import ChatModal from "@/components/Custom/ChatModal.vue";
import OrderSuccessModal from "@/components/Modal/OrderSuccessModal.vue";
import ServiceModal from "@/components/Modal/Services/ServiceModal.vue";
import AlertModal from "@/components/Modal/AlertModal.vue";

// import EventModalApplication from "../Modal/EventModalApplication.vue";
// import EventModalShareNews from "../Modal/News/EventModalShareNews.vue";
// import EventModalShareNewsAdd from "../Modal/News/EventModalShareNewsAdd.vue";
// import EventModalShareNewsDetail from "../Modal/News/EventModalShareNewsDetail.vue";
// import EventModalShareNewsDetailManager from "../Modal/News/EventModalShareNewsDetailManager.vue";
// import EventModalStands from "../Modal/EventModalStands.vue";

export default {
  name: "global-modal",

  components: {
    ServiceModal,
    OrderSuccessModal,
    ChatModal,
    EventModalUsers,
    EventModalCompanyProfile,
    EventModalDetailPass,
    EventModalParticipantPasses,
    EventModalAutoPasses,
    EventModalMontagePasses,
    EventModalCatalog,
    EventModalCatalogRubrics,
    EventModalSubexponent,
    EventModalManagers,
    EventModalChangeCompany,
    EventModalDocumentsIssuedInvoices,
    EventModalDocumentsActs,
    EventModalEdoSettings,
    EventModalCategories,
    FeedbackModal,
    AlertModal
  },
  computed: {
    isOverlayVisible() {
      return Object.keys(this.$store.state.event._overlays).some(
        k => this.$store.state.event._overlays[k]
      );
    }
  },
  methods: {
    hideOverlay() {
      Object.keys(this.$store.state.event._overlays).forEach(key => {
        this.$store.state.event._overlays[key] = false;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 5;
  background: black;
  opacity: 0;
  visibility: hidden;
  transition: 0.1s;

  &--visible {
    opacity: 0.5;
    visibility: visible;
  }
}
</style>
